import type { SetupTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const setupUr: SetupTranslation = {
  models: {
    intro:
      'AI کلید کے ذریعے آپ کے AI ایجنٹس جواب لکھ پاتے ہیں۔ یہ آپ کو OpenAI، Anthropic یا Google جیسی AI کمپنی سے ملتی ہے۔ اسے یہاں چسپاں کریں، ہم آپ کے لیے اس کی جانچ کر دیں گے۔ کلیدیں خفیہ کر کے محفوظ کی جاتی ہیں اور دوبارہ کبھی نہیں دکھائی جاتیں۔',
    empty:
      'پہلی AI کلید شامل کریں تاکہ آپ کے ایجنٹس اصل AI سے جواب دیں۔ اس کے بغیر وہ صرف وہی کلیدیں استعمال کر سکتے ہیں جو سرور کے پاس پہلے سے ہیں (نیچے فہرست میں) اور آف لائن مشق ماڈل، جو بنے بنائے جواب دیتا ہے۔',
    addDescription:
      'چنیں کہ کلید کس نے دی، اسے چسپاں کریں اور ایک ماڈل چنیں۔ ہم اسے خفیہ کر کے محفوظ کرتے ہیں اور فوراً جانچتے ہیں۔',
    model: 'ماڈل',
    modelHint: 'وہ AI ماڈل جس سے کلید کی جانچ ہوگی۔ تجویز کردہ ماڈل اچھی شروعات ہے۔',
    recommended: 'تجویز کردہ',
    customModel: 'کوئی اور ماڈل…',
    customLabel: 'ماڈل کا نام',
    customHint: 'ماڈل کا نام ٹھیک ویسے لکھیں جیسے فراہم کنندہ لکھتا ہے۔',
    customServerHint: 'اپنے سرور کے کسی ماڈل کا نام ٹھیک ویسے لکھیں جیسے سرور لکھتا ہے۔',
    tiers: { fast: 'تیز، کم لاگت', balanced: 'متوازن', capable: 'سب سے قابل' },
    serverAddress: 'سرور کا پتہ',
    serverAddressHint:
      'آپ کے اپنے OpenAI سے مطابقت رکھنے والے سرور کا https:// پتہ، جیسے https://llm.example.com/v1۔',
    labelHint:
      'آپ اور آپ کی ٹیم کے لیے ایک نام، جیسے “OpenAI پروڈکشن”۔ خالی چھوڑنے پر ہم فراہم کنندہ کا نام استعمال کرتے ہیں۔',
    moreOptions: 'مزید اختیارات',
    testNote:
      'محفوظ کرنے کے بعد ہم فراہم کنندہ کو چند الفاظ کا ایک چھوٹا سا جانچ پیغام بھیجتے ہیں تاکہ معلوم ہو کہ کلید چلتی ہے۔ اس کی لاگت ایک سینٹ کے بہت چھوٹے حصے کے برابر ہے۔',
    saveAndTest: 'محفوظ کریں اور جانچیں',
    errors: { model: 'کوئی ماڈل چنیں، یا اس کا نام لکھیں۔' },
    addedOn: '{{date}} کو شامل کیا گیا',
    columns: { lastTest: 'پچھلی جانچ' },
    lastTest: { never: 'ابھی جانچی نہیں گئی', ok: 'چلی' },
    test: 'کلید جانچیں',
    testLabel: '{{label}} کی کلید جانچیں',
    testTitle: '{{label}} کی کلید کی جانچ',
    testDescription:
      'ہم AI فراہم کنندہ کو ایک چھوٹا سا پیغام بھیجتے ہیں اور دکھاتے ہیں کہ کیا جواب آیا۔ آپ کے گاہکوں کی چیٹس میں کچھ نہیں جڑتا۔',
    testing: 'کلید کی جانچ ہو رہی ہے…',
    testingWith: '{{model}} سے کلید کی جانچ ہو رہی ہے…',
    testAgain: 'دوبارہ جانچیں',
    testedWith: 'اس ماڈل سے جانچا گیا',
    probe: {
      ok: { title: 'کلید چلتی ہے', body: 'AI نے ہمارے جانچ پیغام کا جواب دیا۔' },
      wrong_key: {
        title: 'کلید قبول نہیں ہوئی',
        body: 'دیکھیں کہ آپ نے پوری کلید کاپی کی ہے اور وہ اسی فراہم کنندہ کی ہے۔ آپ اسے فہرست سے بدل سکتے ہیں۔',
      },
      no_credit: {
        title: 'کریڈٹ ختم ہو گیا',
        body: 'کلید اصل ہے مگر اکاؤنٹ میں کریڈٹ نہیں بچا۔ فراہم کنندہ کے پاس کریڈٹ شامل کریں اور پھر جانچیں۔',
      },
      model_not_found: {
        title: 'ماڈل نہیں ملا',
        body: 'فراہم کنندہ اس ماڈل کا نام نہیں جانتا۔ فہرست سے کوئی دوسرا ماڈل چنیں یا ہجے دیکھیں۔',
      },
      network: {
        title: 'فراہم کنندہ تک رسائی نہیں ہو سکی',
        body: 'اگر آپ نے سرور کا پتہ دیا ہے تو اسے جانچیں، پھر ایک منٹ بعد دوبارہ کوشش کریں۔',
      },
      blocked: {
        title: 'یہ سرور پتہ قابل قبول نہیں',
        body: 'عوامی https:// پتہ استعمال کریں، یا اپنا Hamnivo سرور چلانے والے سے پوچھیں۔',
      },
      rate_limited: {
        title: 'فراہم کنندہ آہستہ چلنے کو کہہ رہا ہے',
        body: 'ایک منٹ رکیں اور پھر جانچیں۔',
      },
      unavailable: {
        title: 'فراہم کنندہ کو مسئلہ درپیش ہے',
        body: 'چند منٹ بعد دوبارہ کوشش کریں۔',
      },
      unknown: {
        title: 'جانچ نہیں چلی',
        body: 'ہمیں وجہ معلوم نہیں۔ دوبارہ کوشش کریں، یا فراہم کنندہ کے پاس کلید اور ماڈل دیکھیں۔',
      },
    },
    replace: {
      action: 'کلید بدلیں',
      label: '{{label}} کی کلید بدلیں',
      title: '{{label}} کی کلید بدلیں',
      description:
        'نئی کلید چسپاں کریں۔ اس کنکشن کو استعمال کرنے والے ایجنٹس نئی کلید سے چلتے رہتے ہیں اور پرانی کام کرنا بند کر دیتی ہے۔ پہلے آپ سے دوبارہ سائن اِن کرنے کو کہا جا سکتا ہے۔',
      newKey: 'نئی API کلید',
      newKeyHint:
        'موجودہ کلید کے آخری حروف {{hint}} ہیں۔ نئی کلید خفیہ کر کے محفوظ کی جاتی ہے اور دوبارہ نہیں دکھائی جاتی۔',
      submit: 'بدلیں اور جانچیں',
      replaced: '{{label}} کی کلید بدل دی گئی۔',
      done: 'کلید بدل گئی۔ نئی کلید کے آخری حروف {{hint}} ہیں۔',
    },
    server: {
      title: 'اس سرور کی کلیدیں',
      description:
        'آپ کا Hamnivo سرور چلانے والا اسے اپنی AI کلیدیں دے سکتا ہے۔ ایجنٹس یہاں کنکشن بنائے بغیر انہیں استعمال کر سکتے ہیں۔ ہم صرف یہ دکھاتے ہیں کہ کلید لگی ہے یا نہیں، کلید خود کبھی نہیں دکھاتے۔',
      loading: 'سرور کی ترتیبات لوڈ ہو رہی ہیں',
      set: 'کلید لگی ہے',
      notSet: 'کوئی کلید نہیں',
      jev: 'Jev',
      jevHint: 'سوالات کو درست جگہ بھیجتا ہے اور جوابات کی دوبارہ جانچ کرتا ہے۔ اختیاری۔',
      jevOn: 'سیٹ اپ ہے',
      jevOff: 'سیٹ اپ نہیں',
      embeddings: 'معلومات میں تلاش',
      embeddingsMock:
        'سادہ لفظ ملانا، آزمانے کے لیے ٹھیک۔ مفہوم کی بنیاد پر تلاش کے لیے سرور پر OpenAI یا Google کی کلید چاہیے۔',
      embeddingsReady: '{{provider}} سے مفہوم کی بنیاد پر تلاش کرتا ہے۔',
      embeddingsMissing: '{{provider}} استعمال کرنے پر سیٹ ہے، مگر سرور کے پاس اس کی کلید نہیں۔',
      embeddingsOn: 'مفہوم کی بنیاد پر',
      embeddingsBasic: 'سادہ',
      embeddingsNotReady: 'تیار نہیں',
    },
  },
  home: {
    guided: 'رہنمائی والا سیٹ اپ کھولیں',
    steps: {
      brand: {
        title: 'اپنا برانڈ اور ویب سائٹ شامل کریں',
        description: 'برانڈ کا نام دیں اور اپنی ویب سائٹ کو اجازت دیں تاکہ چیٹ وہاں لوڈ ہو سکے۔',
      },
      install: {
        title: 'چیٹ کو اپنی ویب سائٹ پر لگائیں',
        description:
          'کوڈ اپنی ویب سائٹ پر لگائیں اور وہاں کوئی صفحہ کھولیں۔ Studio اسے خود دیکھ لے گا۔',
      },
      engine: {
        title: 'چیٹ انجن جوڑیں',
        description: 'ہر برانڈ کے لیے اسے ایک بار جوڑیں تاکہ چیٹس آپ کی ٹیم تک پہنچیں۔',
      },
      aikey: {
        title: 'AI کلید شامل کریں',
        description:
          'اصل جواب لکھنے کے لیے آپ کے AI ایجنٹس کو OpenAI، Anthropic یا Google جیسی AI کمپنی کی کلید چاہیے۔',
      },
      agent: {
        title: 'AI ایجنٹ شائع کریں',
        description:
          'آپ کا معاون گاہکوں کو تبھی جواب دیتا ہے جب آپ اسے اصل AI ماڈل کے ساتھ شائع کریں، آف لائن مشق ماڈل کے ساتھ نہیں۔',
      },
      team: {
        title: 'ساتھی کو مدعو کریں',
        description: 'ان لوگوں کو شامل کریں جو آپ کے ساتھ چیٹس کا جواب دیں گے۔',
      },
    },
  },
  leave: {
    title: 'بغیر محفوظ کیے چھوڑیں؟',
    description: 'آپ کی کچھ تبدیلیاں محفوظ نہیں ہیں۔ ابھی چھوڑنے پر وہ ضائع ہو جائیں گی۔',
    keep: 'ترمیم جاری رکھیں',
    discard: 'تبدیلیاں چھوڑ دیں',
  },
  appearance: {
    open: 'شکل اور الفاظ',
    openLabel: '{{name}} کی چیٹ کی شکل اور الفاظ بدلیں',
    title: '{{name}} کی چیٹ کی شکل اور الفاظ',
    description:
      'رنگ، لوگو اور وہ الفاظ چنیں جو گاہک دیکھتے ہیں۔ فیلڈز کے ساتھ والی تصویر آپ کے لکھتے ہی بدلتی ہے، اور محفوظ کرنے تک گاہکوں تک کچھ نہیں پہنچتا۔',
    loading: 'چیٹ کی شکل لوڈ ہو رہی ہے',
    previewTitle: 'گاہک کیا دیکھیں گے',
    previewNote: 'چیٹ کی ایک تصویر۔ اصل چیٹ آزمانے کے لیے برانڈ پر “ٹیسٹ چیٹ” استعمال کریں۔',
    previewLabel: 'چیٹ کا پیش منظر',
    previewLanguage: 'زبان',
    previewState: 'کب دکھائیں',
    stateOnline: 'ٹیم آن لائن ہے',
    stateAway: 'ٹیم موجود نہیں',
    colour: {
      label: 'بنیادی رنگ',
      hint: 'چیٹ کی اوپری پٹی، بھیجیں بٹن اور آپ کے گاہکوں کے پیغامات کے لیے استعمال ہوتا ہے۔ رنگ کا کوڈ، جیسے #D17B00۔',
      pick: 'بنیادی رنگ چنیں',
      format:
        '# سے شروع ہونے والا رنگ کا کوڈ استعمال کریں جس میں چھ حروف یا ہندسے ہوں، جیسے #D17B00۔',
      text: 'اس رنگ پر لکھا پڑھنا مشکل ہے۔',
      faint: 'یہ رنگ سفید کے بہت قریب ہے، اس لیے ویب پیج پر نمایاں نہیں ہوتا۔',
      suggest: 'تھوڑا گہرا رنگ، {{colour}}، پڑھنے میں آسان ہے۔',
      apply: '{{colour}} استعمال کریں',
    },
    logo: {
      label: 'لوگو کا ویب پتہ',
      hint: 'آپ کے لوگو کی تصویر کا https:// پتہ، جیسے https://example.com/logo.png۔ یہ آپ کے برانڈ کے نام کے ساتھ چھوٹا دکھائی دیتا ہے۔',
    },
    radius: {
      label: 'کونوں کی گولائی',
      value: '{{px}} px',
      hint: '0 کا مطلب سیدھے کونے۔ بڑے عدد یعنی زیادہ گول۔',
    },
    greeting: {
      label: 'خوش آمدید کا پیغام',
      hint: 'گاہک سب سے پہلے یہی پڑھتے ہیں۔ Hamnivo کا پیغام استعمال کرنے کے لیے خالی چھوڑیں۔ پہلے انگریزی لکھیں: دوسری زبانیں اسی پر لوٹتی ہیں۔',
    },
    offline: {
      label: 'کوئی آن لائن نہ ہو تو پیغام',
      hint: 'جب گاہک آپ کے کام کے اوقات کے باہر کسی شخص کو مانگتے ہیں تو وہ یہ پڑھتے ہیں۔ جہاں آپ کی ٹیم کے لوٹنے کا وقت آنا چاہیے وہاں {when} لکھیں۔ Hamnivo کا پیغام استعمال کرنے کے لیے خالی چھوڑیں۔',
    },
    csat: {
      label: 'گاہکوں سے چیٹ کی درجہ بندی مانگیں',
      hint: 'چیٹ ختم ہونے پر گاہک 1 سے 5 ستارے دے سکتے ہیں اور تبصرہ چھوڑ سکتے ہیں۔',
    },
    privacy: {
      label: 'پرائیویسی پالیسی کا ویب پتہ',
      hint: 'چیٹ کے نیچے لنک کی طرح دکھائی دیتا ہے، جیسے https://example.com/privacy۔',
    },
    urlProblem: 'https:// سے شروع ہونے والا ویب پتہ استعمال کریں جس میں صارف نام یا پاس ورڈ نہ ہو۔',
    englishFirst: 'پہلے انگریزی متن لکھیں۔ دوسری زبانیں اسی پر لوٹتی ہیں۔',
    reset: 'ری سیٹ کریں',
    save: 'شکل محفوظ کریں',
    saved: '{{name}} کی چیٹ کی شکل محفوظ ہو گئی۔',
  },
  testChat: {
    open: 'ٹیسٹ چیٹ',
    openLabel: '{{name}} کی چیٹ آزمائیں',
    needsEngine: 'پہلے اس برانڈ کے لیے چیٹ انجن جوڑیں۔',
    title: '{{name}} کے لیے ٹیسٹ چیٹ',
    description:
      'یہ آپ کی اصل چیٹ ہے جو Studio کے اندر چل رہی ہے۔ ایک پیغام بھیج کر دیکھیں کہ وہ کیسی دکھتی ہے اور AI کیا جواب دیتا ہے۔',
    frameTitle: '{{name}} کے لیے ٹیسٹ چیٹ',
    noteReal: 'یہ اصل چیٹ ہے: AI آپ کی اصل کلید اور اپنی معلومات سے جواب دیتا ہے۔',
    noteReports: 'ٹیسٹ چیٹس آپ کی رپورٹس اور گنتی میں شامل نہیں ہوتیں۔',
    noteUsage:
      'وہ کسی بھی چیٹ کی طرح آپ کے پلان کا استعمال کرتی ہیں، اور ان باکس میں دکھائی دے سکتی ہیں۔',
  },
  brand: 'برانڈ',
  hours: {
    nav: 'کام کے اوقات',
    title: 'کام کے اوقات',
    description:
      'گاہکوں کو بتائیں کہ آپ کی ٹیم کب جواب دیتی ہے۔ ان اوقات کے باہر چیٹ بتاتی ہے کہ کوئی آن لائن نہیں اور آپ کب لوٹیں گے۔ آپ کا AI معاون ہر وقت جواب دیتا ہے۔',
    edit: 'کام کے اوقات بدلیں',
    notSet: 'طے نہیں ہیں۔ اوقات طے کرنے تک چیٹ کبھی نہیں کہتی کہ کوئی شخص دستیاب ہے۔',
    closedAlways: 'ہر دن بند',
    closedDays: 'بند دن: {{n}}',
    to: 'سے',
    loading: 'کام کے اوقات لوڈ ہو رہے ہیں',
    noBrands: {
      title: 'ابھی کوئی برانڈ نہیں',
      description: 'کام کے اوقات کسی برانڈ کے ہوتے ہیں۔ پہلے ایک برانڈ شامل کریں۔',
      action: 'برانڈز پر جائیں',
    },
    timezone: {
      label: 'ٹائم زون',
      hint: 'نیچے کے اوقات اسی ٹائم زون میں ہیں، چاہے آپ کے گاہک کہیں بھی ہوں۔',
    },
    presets: {
      weekdays: 'پیر سے جمعہ، 9:00 سے 17:00',
      everyday: 'ہر دن، پورے دن',
      closed: 'ہر دن بند',
    },
    week: {
      title: 'ہفتے کے اوقات',
      hint: 'وہ دن چنیں جب آپ کی ٹیم جواب دیتی ہے اور وقت طے کریں۔ بند ہونے کا وقت 12:00 AM یعنی اس دن کے آخر کی آدھی رات۔',
      open: 'کھلا',
      opens: 'کھلتا ہے',
      closes: 'بند ہوتا ہے',
      add: 'ایک اور وقت شامل کریں',
      remove: '{{day}} کا یہ وقت ہٹائیں',
    },
    holidays: {
      title: 'بند دن',
      description:
        'سرکاری چھٹیاں اور دوسرے پورے دن جب کوئی جواب نہیں دیتا۔ ان دنوں چیٹ بتاتی ہے کہ کوئی آن لائن نہیں۔',
      date: 'دن',
      add: 'دن شامل کریں',
      remove: '{{date}} ہٹائیں',
      none: 'کوئی بند دن نہیں۔',
    },
    problems: {
      time: '{{day}} کے لیے کھلنے اور بند ہونے کا وقت درج کریں۔',
      order: '{{day}} کو بند ہونے کا وقت کھلنے کے بعد کا ہونا چاہیے۔',
      overlap: '{{day}} کو اوقات آپس میں ٹکرانے نہیں چاہییں۔',
      zone: 'فہرست سے کوئی ٹائم زون چنیں۔',
      date: 'بند دنوں میں سے ایک تاریخ نہیں ہے۔',
    },
    save: 'اوقات محفوظ کریں',
    saved: '{{name}} کے کام کے اوقات محفوظ ہو گئے۔',
    reset: 'ری سیٹ کریں',
    unsaved: 'آپ کی کچھ تبدیلیاں محفوظ نہیں ہیں۔',
    noPermission: 'کام کے اوقات بدلوانے کے لیے کسی مالک یا ایڈمن سے کہیں۔',
    remove: {
      action: 'اوقات ہٹائیں',
      title: '{{name}} کے اوقات ہٹائیں؟',
      body: 'اس کے بعد چیٹ کبھی نہیں کہتی کہ کوئی شخص دستیاب ہے۔ آپ کسی بھی وقت اوقات دوبارہ طے کر سکتے ہیں۔',
      confirm: 'اوقات ہٹائیں',
      done: '{{name}} کے اوقات ہٹا دیے گئے۔',
    },
  },
  identity: {
    nav: 'گاہک سائن اِن',
    title: 'گاہک سائن اِن',
    description:
      'اپنی ویب سائٹ کو Hamnivo کو بتانے دیں کہ سائن اِن کیا ہوا گاہک کون ہے، تاکہ وہ ہر ڈیوائس پر اپنی چیٹس دیکھ سکے۔ اسے کوئی ڈویلپر سیٹ اپ کرتا ہے؛ اگر آپ کے گاہک ویب سائٹ پر سائن اِن نہیں کرتے تو آپ اسے چھوڑ سکتے ہیں۔',
    guide: 'ڈویلپرز کے لیے گائیڈ پڑھیں',
    loading: 'گاہک سائن اِن کلیدیں لوڈ ہو رہی ہیں',
    noBrands: 'گاہک سائن اِن کسی برانڈ کا ہوتا ہے۔ پہلے ایک برانڈ شامل کریں۔',
    noPermission: 'ان کلیدوں کا انتظام کرنے کے لیے کسی مالک یا ایڈمن سے کہیں۔',
    empty: {
      title: 'ابھی کوئی کلید نہیں',
      description:
        'آپ کی ویب سائٹ کا سرور گاہک کے بارے میں ایک مختصر نوٹ کلید سے دستخط کرتا ہے۔ کلید یہاں بنائیں اور اپنے ڈویلپر کو دیں۔',
    },
    columns: {
      name: 'کلید کا نام',
      type: 'قسم',
      status: 'صورتحال',
      added: 'شامل کی گئی',
      actions: 'اقدامات',
    },
    algs: {
      HS256: 'مشترکہ خفیہ کلید (HS256)',
      ES256: 'عوامی کلید (ES256)',
      EdDSA: 'عوامی کلید (EdDSA)',
      RS256: 'عوامی کلید (RS256)',
    },
    status: { active: 'فعال', retiring: 'جلد ختم ہوگی', revoked: 'منسوخ' },
    create: {
      action: 'کلید بنائیں',
      title: 'گاہک سائن اِن کلید بنائیں',
      description:
        'کلیدوں کے انتظام کے لیے دو مرحلوں والی تصدیق اور حالیہ سائن اِن ضروری ہے۔ آپ سے دوبارہ سائن اِن کرنے کو کہا جا سکتا ہے۔',
      kind: 'کس قسم کی کلید؟',
      secret: 'مشترکہ خفیہ کلید',
      secretHint:
        'Hamnivo اسے آپ کے لیے بناتا ہے اور ایک بار دکھاتا ہے۔ شروع کرنے کا سب سے آسان طریقہ۔',
      public: 'عوامی کلید',
      publicHint: 'نجی کلید آپ کے سرور پر رہتی ہے اور آپ Hamnivo کو صرف عوامی حصہ دیتے ہیں۔',
      alg: 'دستخط کی قسم',
      jwk: {
        label: 'عوامی کلید (JWK)',
        hint: 'عوامی کلید کو JSON کی شکل میں چسپاں کریں۔ نجی کلید کبھی چسپاں نہ کریں: Hamnivo اسے قبول نہیں کرتا۔',
        json: 'یہ درست JSON نہیں ہے۔',
        object: 'ایک کلید کو JSON آبجیکٹ کے طور پر چسپاں کریں۔',
        private: 'یہ نجی کلید لگتی ہے۔ صرف عوامی حصہ چسپاں کریں۔',
      },
      name: 'کلید کا نام',
      nameHint:
        'حروف، ہندسے، نقطہ، انڈر سکور اور ڈیش، 64 تک۔ خالی چھوڑنے پر Hamnivo ایک چن لیتا ہے۔',
      nameInvalid: 'صرف حروف، ہندسے، نقطہ، انڈر سکور اور ڈیش استعمال کریں، 64 تک۔',
      submitSecret: 'خفیہ کلید بنائیں',
      submitPublic: 'کلید درج کریں',
    },
    rotate: {
      action: 'بدلیں',
      label: 'کلید {{kid}} بدلیں',
      title: 'کلید {{kid}} بدلیں',
      description:
        'ہم اسی قسم کی نئی کلید بناتے ہیں اور اس کلید کو “جلد ختم ہوگی” کا نشان لگاتے ہیں۔ ایسی کلید ابھی چلتی رہتی ہے، اس لیے آپ کا سرور بغیر رکاوٹ نئی کلید پر آ سکتا ہے۔',
      retireFailed:
        'نئی کلید بن گئی، مگر {{kid}} کو “جلد ختم ہوگی” کا نشان نہیں لگایا جا سکا۔ اس کی قطار میں دوبارہ “بدلیں” آزمائیں، یا جب کوئی اسے استعمال نہ کرے تو اسے منسوخ کریں۔',
    },
    revoke: {
      action: 'منسوخ کریں',
      label: 'کلید {{kid}} منسوخ کریں',
      title: 'کلید {{kid}} منسوخ کریں؟',
      body: 'اس کلید سے دستخط شدہ ہر چیز اب سے رد کر دی جائے گی۔ یہ تبھی کریں جب آپ کو یقین ہو کہ آپ کا سرور اب اسے استعمال نہیں کرتا۔',
      confirm: 'کلید منسوخ کریں',
      done: 'کلید {{kid}} منسوخ کر دی گئی۔',
    },
    how: {
      title: 'بغیر رکاوٹ کلید بدلنا',
      description: 'اسے اسی ترتیب سے کریں تاکہ گاہک کبھی باہر نہ ہو جائیں۔',
      step1:
        'جو کلید چل رہی ہے اس پر “بدلیں” دبائیں۔ نئی کلید بنتی ہے اور پرانی کو “جلد ختم ہوگی” کا نشان لگ جاتا ہے۔',
      step2: 'نئی کلید اپنے ڈویلپر کو دیں، جو آپ کی ویب سائٹ کے سرور کو اس پر لے آئے گا۔',
      step3: 'جب کوئی بھی پرانی کلید استعمال نہ کرے تو اس پر “منسوخ کریں” دبائیں۔',
    },
    created: 'کلید {{kid}} بن گئی۔',
    reveal: { title: 'آپ کی نئی خفیہ کلید', label: 'کلید {{kid}} کی خفیہ کلید' },
  },
  teams: {
    nav: 'سپورٹ ٹیمیں',
    title: 'سپورٹ ٹیمیں',
    description:
      'ہر ٹیم میں کون ہے۔ چیٹس ٹیموں کے سپرد کی جاتی ہیں۔ یہاں لوگوں کو شامل کریں یا ہٹائیں۔',
    loading: 'ٹیمیں لوڈ ہو رہی ہیں',
    noPermission: 'ٹیمیں بدلوانے کے لیے کسی مالک یا ایڈمن سے کہیں۔',
    empty: {
      title: 'ابھی کوئی ٹیم نہیں',
      description:
        'ٹیم ان لوگوں کا گروپ ہے جو مل کر چیٹس کا جواب دیتے ہیں، جیسے “سپورٹ” یا “سیلز”۔',
    },
    create: 'ٹیم بنائیں',
    createTitle: 'ٹیم بنائیں',
    createDescription: 'ٹیم کو ایک نام دیں۔ اس کے بعد اس کے لوگوں کو شامل کریں۔',
    name: 'ٹیم کا نام',
    nameHint: 'جیسے “سپورٹ” یا “سیلز”۔',
    nameRequired: 'ٹیم کو ایک نام دیں۔',
    created: 'ٹیم {{name}} بن گئی۔',
    archived: 'آرکائیو شدہ',
    count: 'اس ٹیم میں لوگ: {{n}}',
    noMembers: 'اس ٹیم میں ابھی کوئی نہیں۔',
    remove: '{{name}} کو {{team}} سے ہٹائیں',
    removed: '{{name}} کو {{team}} سے ہٹا دیا گیا۔',
    addLabel: 'کسی کو شامل کریں',
    choose: 'کسی کو چنیں',
    everyone: 'سب پہلے سے اس ٹیم میں ہیں',
    add: 'ٹیم میں شامل کریں',
    added: '{{name}} کو {{team}} میں شامل کیا گیا۔',
    rules: 'چیٹس ٹیموں تک ہر برانڈ کے قواعد سے پہنچتی ہیں۔',
    rulesLink: 'قواعد کھولیں',
  },
  install: {
    platforms: {
      html: 'کوئی بھی ویب سائٹ',
      wordpress: 'WordPress',
      woocommerce: 'WooCommerce',
      shopify: 'Shopify',
      whmcs: 'WHMCS',
      wix: 'Wix',
      squarespace: 'Squarespace',
      webflow: 'Webflow',
      'google-tag-manager': 'Google Tag Manager',
      react: 'React',
      vue: 'Vue',
      nextjs: 'Next.js',
    },
  },
  onboarding: {
    title: 'Hamnivo میں خوش آمدید',
    description:
      'چند ہی منٹوں میں سیٹ اپ کریں۔ ہر مرحلہ چھوڑا جا سکتا ہے اور بعد میں کیا جا سکتا ہے، اور چھوڑ کر جانے پر بھی آپ کا کیا ہوا کچھ ضائع نہیں ہوتا۔',
    later: 'بعد میں مکمل کریں',
    loading: 'آپ کا سیٹ اپ لوڈ ہو رہا ہے',
    railLabel: 'سیٹ اپ کے مراحل',
    count: '{{total}} میں سے {{done}} مراحل نمٹ گئے',
    stepOf: 'مرحلہ {{n}} / {{total}}',
    back: 'واپس',
    skip: 'یہ مرحلہ چھوڑیں',
    continue: 'آگے بڑھیں',
    needsBrand: 'اس مرحلے کے لیے برانڈ چاہیے۔ پہلے ایک شامل کریں۔',
    toBrand: 'برانڈ شامل کریں',
    state: { done: 'ہو گیا', skipped: 'چھوڑا گیا', todo: 'ابھی نہیں ہوا' },
    steps: {
      workspace: {
        name: 'ورک اسپیس',
        title: 'آپ کی ورک اسپیس',
        description: 'آپ کے کاروبار سے متعلق ہر چیز یہاں رہتی ہے۔',
      },
      brand: {
        name: 'برانڈ اور ویب سائٹ',
        title: 'آپ کا برانڈ اور ویب سائٹ',
        description:
          'ہر برانڈ کی اپنی چیٹ، اجازت یافتہ ویب سائٹ اور AI معاون ہوتا ہے۔ ہمیں اس کا نام بتائیں اور یہ بھی کہ چیٹ کہاں دکھائی دے گی۔',
      },
      engine: {
        name: 'چیٹ انجن',
        title: 'چیٹ انجن جوڑیں',
        description:
          'چیٹ انجن آپ کے گاہکوں کے پیغامات آپ کی ٹیم تک پہنچاتا ہے۔ یہ خود سیٹ اپ ہو جاتا ہے۔',
      },
      aikey: {
        name: 'AI کلید',
        title: 'AI کلید شامل کریں',
        description:
          'AI کلید کے ذریعے آپ کے AI ایجنٹس جواب لکھ پاتے ہیں۔ کسی AI کمپنی کی کلید چسپاں کریں اور ہم جانچیں گے کہ وہ چلتی ہے۔',
      },
      testchat: {
        name: 'ٹیسٹ چیٹ',
        title: 'چیٹ خود آزمائیں',
        description: 'کسی گاہک کے دیکھنے سے پہلے اپنی ہی چیٹ میں ایک پیغام بھیجیں۔',
      },
      install: {
        name: 'انسٹال',
        title: 'چیٹ کو اپنی ویب سائٹ پر لگائیں',
        description: 'چنیں کہ آپ کی ویب سائٹ کس سے بنی ہے، پھر کوڈ اس میں کاپی کریں۔',
      },
      team: {
        name: 'ٹیم',
        title: 'اپنی ٹیم کو مدعو کریں',
        description:
          'ان لوگوں کو شامل کریں جو آپ کے ساتھ چیٹس کا جواب دیں گے۔ یہ بعد میں بھی کیا جا سکتا ہے۔',
      },
    },
    workspace: {
      ready: 'آپ کی ورک اسپیس {{name}} تیار ہے۔',
    },
    brand: {
      existing: 'سیٹ اپ کرنے کے لیے برانڈ',
      existingHint: 'یہ برانڈز آپ کی ورک اسپیس میں پہلے سے موجود ہیں۔',
      use: '{{name}} کے ساتھ آگے بڑھیں',
      addAnother: 'دوسرا برانڈ شامل کریں',
      website: 'آپ کی ویب سائٹ',
      websiteHint:
        'جہاں چیٹ دکھائی دے گی، جیسے noor.example۔ صرف یہی ویب سائٹ چیٹ دکھا سکتی ہے۔ آپ اسے بعد میں بدل سکتے ہیں۔',
      create: 'برانڈ بنائیں',
      websiteInvalid:
        '{{value}} ویب سائٹ کا پتہ نہیں ہے۔ اسے یوں لکھیں: noor.example یا https://noor.example۔',
      useExisting: 'میرے پاس جو برانڈ ہے وہی استعمال کریں',
    },
    engine: {
      checking: 'آپ کا چیٹ انجن جانچا جا رہا ہے…',
      working: '{{name}} کے لیے چیٹ انجن سیٹ اپ ہو رہا ہے۔ اس میں تھوڑا وقت لگتا ہے۔',
      ready: 'آپ کا چیٹ انجن تیار ہے۔',
      retry: 'دوبارہ کوشش کریں',
      disabled: 'کنکشن بند ہے۔ کسی ایڈمن سے اسے چالو کرنے کو کہیں۔',
      slow: 'اس میں معمول سے زیادہ وقت لگ رہا ہے۔ آپ یہاں انتظار کر سکتے ہیں، یا یہ مرحلہ چھوڑ کر بعد میں "برانڈز اور انسٹال" میں چیٹ انجن جوڑ سکتے ہیں۔',
      stopped: 'سیٹ اپ رک گیا: {{error}} دوبارہ کوشش کریں: یہ وہیں سے آگے بڑھے گا جہاں رکا تھا۔',
      cancelled: 'سائن اِن بند کر دیا گیا، اس لیے سیٹ اپ شروع نہیں ہوا۔',
    },
    aikey: {
      noPermission:
        'AI کلید صرف وہی شامل کر سکتے ہیں جو کنکشنز کا انتظام کرتے ہیں۔ کسی مالک یا ایڈمن سے کہیں، یا یہ مرحلہ چھوڑ دیں۔',
      serverKey:
        'اس سرور کے پاس اپنی ایک AI کلید پہلے سے ہے، اس لیے آپ کے ایجنٹس یہاں کلید کے بغیر بھی جواب دے سکتے ہیں۔ اپنے اکاؤنٹ کو استعمال کرنے کے لیے اپنی کلید شامل کریں۔',
      have: 'آپ کے پاس پہلے سے ایک AI کلید ہے۔ جانچ کر دیکھیں کہ وہ چلتی ہے۔',
    },
    testchat: {
      toEngine: 'چیٹ انجن والے مرحلے پر جائیں',
      done: 'چل رہی ہے، آگے بڑھیں',
    },
    install: {
      platform: 'آپ کی ویب سائٹ کس سے بنی ہے؟',
      platformHint: 'ہم اس کی گائیڈ کا لنک دیتے ہیں۔ یقین نہ ہو تو “کوئی بھی ویب سائٹ” رہنے دیں۔',
      guide: 'انسٹالیشن گائیڈ کھولیں: {{platform}}',
      where: 'یہ کوڈ کہاں جاتا ہے؟',
      whereBody:
        'اسے ہر اس صفحے پر چسپاں کریں جہاں چیٹ دکھائی دینی چاہیے، بند ہونے والے </body> ٹیگ سے ٹھیک پہلے۔ ویب سائٹ بلڈر میں کسٹم کوڈ یا فوٹر میں اسکرپٹ شامل کرنے کی جگہ تلاش کریں۔ اوپر کی گائیڈ ٹھیک جگہ دکھاتی ہے۔',
      addWebsite: 'اپنی ویب سائٹ شامل کریں',
      status: {
        waiting: 'آپ کی ویب سائٹ کا انتظار ہے',
        waitingBody:
          'کوڈ لگائیں، ویب سائٹ محفوظ یا شائع کریں، پھر اس کا کوئی بھی صفحہ کھولیں۔ چیٹ وہاں لوڈ ہوتے ہی یہ خود بدل جائے گا۔',
        check: 'ابھی جانچیں',
        found: 'چیٹ آپ کی ویب سائٹ پر ہے',
        foundBody:
          'اپنی ویب سائٹ کا کوئی صفحہ کھولیں اور چیٹ سے ایک پیغام بھیجیں: وہ آپ کے ان باکس میں نظر آئے گا۔',
        lastSeen: 'آخری بار {{time}} دیکھا گیا',
        help: 'نظر نہیں آ رہا؟',
        helpExact:
          'صفحہ اوپر دی گئی کسی ویب سائٹ پر بالکل اسی پتے پر ہونا چاہیے، اسی https اور www کے ساتھ۔',
        helpCache:
          'محفوظ کرنے کے بعد صفحہ کھولیں، یا اپنی ویب سائٹ کا کیش صاف کریں، تاکہ نیا کوڈ استعمال ہو۔',
        helpPolicy:
          'اگر آپ کی ویب سائٹ پر کنٹینٹ سیکیورٹی پالیسی ہے، تو اسے Hamnivo کی اسکرپٹس، فریمز اور کنکشنز کی اجازت دینی ہوگی۔',
        onWebsite: 'آپ کی ویب سائٹ پر',
        notSeen: 'ابھی تک نہیں دیکھا گیا',
      },
      done: 'میں نے کوڈ شامل کر دیا',
    },
    team: {
      none: 'یہاں ابھی آپ کے سوا کوئی نہیں۔ آپ لوگوں کو ابھی یا بعد میں مدعو کر سکتے ہیں۔',
      some: 'آپ کی ورک اسپیس میں آپ کے سوا لوگ: {{people}}۔ بھیجے گئے دعوت نامے: {{invited}}۔',
      invite: 'ساتھی کو مدعو کریں',
      finish: 'سیٹ اپ مکمل کریں',
      noPermission: 'لوگوں کو مدعو کرنے کے لیے کسی مالک یا ایڈمن سے کہیں۔',
    },
    finished: {
      title: 'سب تیار ہے',
      titleOpen: 'سیٹ اپ محفوظ ہو گیا',
      description: 'سب کچھ ہو گیا۔ آپ ان میں سے کچھ بھی بعد میں مینو سے بدل سکتے ہیں۔',
      descriptionOpen:
        'باقی مراحل: {{n}}۔ آپ انہیں ابھی یا کسی بھی وقت کر سکتے ہیں؛ ہوم کی فہرست ان کا حساب رکھتی ہے۔',
      doSkipped: 'ابھی کریں',
      doTodo: 'ابھی کریں',
      go: 'ہوم پر جائیں',
    },
  },
};
